import Button, { btnSizeClass } from '~/components/Buttons/Button'
import { ButtonProps } from '~/components/Buttons/types'

interface Props {
  isSelected?: boolean
  isWrong?: boolean
}
export function SelectionButton({
  isSelected = false,
  isWrong,
  isAutoWidth,
  isWide,
  className = '',
  size,
  children,
  ...rest
}: ButtonProps & Props): React.ReactElement {
  return (
    <Button
      size={size}
      {...rest}
      className="active:transform-none outline-0 focus:outline-0 group"
      isFullWidth
      noPadding
    >
      <span
        className={`${
          'flex items-center justify-center ' +
          'rounded focus:outline-none tap-appearance-none ' +
          'font-medium ' +
          'ring-2 lg:hover:ring-purple-dark ' +
          'focus:ring-8 lg:focus:ring-purple-light lg:disabled:ring-purple ' +
          ' ' +
          'lg:disabled:text-purple ' +
          'transition transform scale-100 group-active:scale-95 h-full '
        }${isWrong ? 'ring-red-wrong-choice ' : 'ring-purple '}${
          isSelected
            ? 'bg-purple text-white focus:text-white'
            : 'text-purple-focus focus:text-purple-focus lg:hover:text-purple-dark'
        } ${btnSizeClass(size, true, isAutoWidth, isWide, false)} ${className}`}
      >
        {children}
      </span>
    </Button>
  )
}
